import CameraHandlerBase from "./camera-handler-base";
import ThreeRenderSpace from "../render-spaces/three-render-space";
//import { Vector3 } from "three";
import * as THREE from 'three';
import UtilSP from "SATPROF_UTILS/UtilSP";
import TimingInfo from "../timing-info";
import { Vector3 } from "three";
import { TraceLevel } from "@awayfl/avm1";
import String3D_grp from "SATPROF_LIBRARY/ThreeDParts/String3D_grp";
import { alIterateArray } from "@awayfl/avm1/dist/lib/runtime";


export default class UniversalCameraHandler extends CameraHandlerBase {

/*
Properties and methods
distance (responds to mousewheen if not in Orbit mode)
pixelSnap
pan
tilt
snapTo(pan, tilt, dist)
FOV  (responds to mousewheen if in Orbit mode)
cameraType  "ortho" "perspective" "fishEye";
orthoZoom   Applies only to orthographic camera
orbitMode   boolean
enableMouseAndWheel  (same as enable both drag and wheel)
enableDrag
enableWheel
positionSummary string r/o
lookat  THREE.Vector3
lookatX
lookatY
lookatZ
posX
posY
posZ
pos THREE.Vector3
placeCamera("orbit", new Vector3D(-75,2085,27.4), camPan, 0, 50, 3500, true);
enableTweening
consoleLogShortSummary

pthParentOrbitMode  Sets the object that is to be the parent of the pan-tilt head, e.g. Earth vs. whole renderspace



In pan-tilt mode: pan = 0 points camera along Z axis


pth is pan-tilt head.  Camera remains a child of pth

pth becomes a child of:
    renderspace.scene           In Orbit mode (_orbitMode = true_)
    pthParent                   In Pan-tilt mode (_orbitMode = false)

pth has children:
    camPan_grp      Rotates to implement _camPan
        camTilt_grp Rotatoins to implement _camTilt
            camera


_camPan     Pan of camera on pth
_camTilt     Tilt of camera on pth
_pthPan     Pan of the pth around the lookat point
_pthTilt    Tilt of the pth around the lookat point
_pthPos     v3 Postion of the pth in its parent's frame
_distance
_lookAt     v3

Update (Orbit mode):
_camPan, _camTilt = 0
pan  --> _pthPan
tilt --> _pthTilt
lookat --> _lookAt
Calc  _pthPos from _lookAt, _distance, _pthPan, _pthTilt, and put pth there,
set pth lookat to _lookAt

Update (pantilt mode):
pan  --> _campPan
tilt --> _camTilt
_pthPan, _pthTilt = 0;
pos --> pth position
No rotation of pth (how?)
Ignore distance and lookat

On switch from orbit to pantilt mode:
Switch pth parent from scene to pthParent
set pth position to 0,0,0
set pth rotation back to 0 (how?)



On switch from pantilt to orbit mode:
Switch pth parent
Convert current pth pos from previous parent to new parent (scene)
calculate pan and tilt from pos and lookat
update

*/

    private _consoleLogShortSummary:boolean = false;
    private _mouseIsDown:boolean = false;
    private _lastxStage:number = 0;
    private _lastyStage:number = 0;
    private _pixelSnap:number = 1;
    private _azOffset:number = 0;
    private _netAz:number = 0;

    private _currentTilt:number = 0;
    private _currentPan:number = 0;
    private _currentFOV:number = 45;
    private _currentDist:number = 80000;
    private _currentLookat:THREE.Vector3;
    private _currentPos:THREE.Vector3;
    private _currentOrthoZoom:number = 1;

    private _targetTilt:number = 0;
    private _targetPan:number = 0;
    private _targetFOV:number = 45;
    private _targetDist:number = 80000;
    private _targetLookat:THREE.Vector3;
    private _targetPos:THREE.Vector3;
    private _targetOrthoZoom:number = 1;

    private _enableTweening:boolean = true;
    private tweenTimer:TimingInfo;
    private _stillTweening:boolean = false;;
    private _orbitMode:boolean = true;
    private vTilt:number = 10; // Deg per second tween velocity
    private vPan:number = 10; // Deg per second tween velocity
    private vFOV:number = 5; // Deg per second tween velocity
    private vDist:number = 10; // Deg per second tween velocity
    private _minFOV:number = 5;
    private _maxFOV:number = 100;
    private _minDistance:number = 0;
    private _maxDistance:number = 1e9;
    private _tweeningIsActive:boolean = false;
    private _allowOutOfBounds:boolean = false;
    public pth:THREE.Group;
    public _pthParentPanTiltMode:THREE.Object3D|THREE.Scene;
    public _pthParentOrbitMode:THREE.Object3D|THREE.Scene;
    public camPan_grp:THREE.Group;
    public camTilt_grp:THREE.Group;
    public camHolder_grp:THREE.Group;
    public lastMousePos:any;
    private _enableDrag:boolean = true;
    private _enableWheel:boolean = true;
    //private _enableMouseAndWheel:boolean = true;
    private _shortSummary:string = "";

    private _tiltMin:number = -1e99;
    private _tiltMax:number = 1e99;
    private azElGridDome:THREE.Group;
    private constantElCircle:THREE.Group;
    private _showAzElGridDome:boolean = false;
    private _showConstantElCircle:boolean = true;
    private _constantElCircleElevation = 45; //37;
    private _constantElCircleWallColor:string = "red";
    private _constantElCircleWallAlpha0_100:number = 30;
    private _showConstantElCircleWall:boolean = false;


   // on register is where we bootstrap events
    onRegister(myrenderSpace : ThreeRenderSpace) {
        //console.log("In unicam.onRegister()");
        super.onRegister(myrenderSpace);
        this.initialize();
    }
    private initialize(){
        this.pth = new THREE.Group;
        this.pth.name = "pth";
        this.camPan_grp = new THREE.Group; // y rotation makes Pan
        this.camPan_grp.name = "camPan_grp";
        this.camPan_grp.position.y = 0;
        this.camTilt_grp = new THREE.Group; // x rotation makes Tilt
        this.camTilt_grp.name = "camTilt_grp";
        this.camHolder_grp = new THREE.Group;
        this.camHolder_grp.name = "camHolder_grp";

        this.pth.add(this.camPan_grp);
        this.camPan_grp.add(this.camTilt_grp);
        this.camTilt_grp.add(this.camHolder_grp);

        ////this.camTilt_grp.add(this.renderSpace.camera);
        ////this.renderSpace.scene.add(this.renderSpace.camera);
        this.renderSpace.camera.name = "mycamera";
        this.cameraType = "perspective"; 

        this.pth.position.x = 0;
        this.pth.position.y = 0;
        this.pth.position.z = 70000;
        this.camPan_grp.rotation.y = UtilSP.radians(-20);
        this.camTilt_grp.rotation.x = UtilSP.radians(10);

        this.camHolder_grp.add(this.renderSpace.camera_p);
        this.camHolder_grp.add(this.renderSpace.camera_f);
        this.camHolder_grp.add(this.renderSpace.camera_o);

        this._pthParentPanTiltMode = this.renderSpace.scene; // Default
        this._pthParentOrbitMode = this.renderSpace.scene; // Default
        this.tweenTimer = new TimingInfo();
        this.tweenTimer.reset();
        this._currentLookat = new THREE.Vector3(0,0,0);
        this._currentPos = new THREE.Vector3(100000,0,0); // Abritrary
        this._targetLookat = new THREE.Vector3(0,0,0);
        this._targetPos = new THREE.Vector3(100000,0,0); // Abritrary     

        this.azElGridDome = new THREE.Group();
        this.pth.add(this.azElGridDome);
        this.makeAzElGridDome();
        this.showAzElGridDome = false;

        this.constantElCircle = new THREE.Group();
        this.pth.add(this.constantElCircle);
        this.makeConstantElCircle();

        this.orbitMode = true;

        // add event listeners
        this.renderSpace.addEventListener("mousedown", (event)=>{
            //console.log("In universal-camera-handler mousedown handler");
            if (this._enableDrag){
                const pos = canvasPos(this.renderSpace.getCanvas(), event);
                this.lastMousePos = pos;
                //console.log("In universal-camera-handler mousedown handler: _enableMouseAndWheel = "+this._enableMouseAndWheel
                //+", pos.outOfBounds = "+pos.outOfBounds+", this._allowOutOfBounds = "+this._allowOutOfBounds);                
                if (!pos.outOfBounds || this._allowOutOfBounds){
                    this._mouseIsDown = true;
                    this._enableTweening = false; //Cancel tweening if user clicks in the 3D canvas, and don't update the camera.
                    this._lastxStage = pos.x;
                    this._lastyStage = pos.y;  
                }
            }

        })

        window.addEventListener("mouseup", (event)=>{
            this._mouseIsDown = false;
        })

        window.addEventListener("mousemove", this.onMouseMove.bind(this));

        this.renderSpace.addEventListener("wheel", (event : WheelEvent) => {

            //console.log("In universal-camera-handler, cameraType = "+this.cameraType+ ", _currentOrthoZoom = "+this._currentOrthoZoom);

            if(!this.lastMousePos){
                // Mouse pos has not been captured yet
                return;
            }   
            if(this.lastMousePos.outOfBounds){
                return;
            }
            if (!this._enableWheel){
                return;
            }

            //// Put distance adjuster here
            let dY:number = event.deltaY; // returns -100 for each wheel click forward, +100 per click backward
            if (this._orbitMode){
                let newDistance:number = this.distance * (1 + dY/1000);
                newDistance = UtilSP.minmax(newDistance, this._minDistance, this._maxDistance );
                this.distance = newDistance;
            } else {
                let newFOV:number = this.FOV * (1 + dY/1000);
                newFOV = UtilSP.minmax(newFOV, this._minFOV, this._maxFOV );
                this.FOV = newFOV;
            } 
            ////
            let newOrthoZoom:number = this.orthoZoom * (1 - dY/1000);
            //console.log( "In unicam, orthoZoom was "+this.orthoZoom+", dY =  "+dY+", newOrthoZoom = "+newOrthoZoom);
            if (this.cameraType == "ortho"){
                this.orthoZoom = newOrthoZoom;
                console.log('ortho')
                //console.log( "now, this.orthoZoom = "+this.orthoZoom);
            }
            this.updateCamera();
        });

        // Finally, use setters to initialize settings.
        this.orbitMode = true;

    }
 	private makeAzElGridDome(){

		let masterCircleAz_p:Array<THREE.Vector3> = [];
		let masterCircleEl_p:Array<THREE.Vector3> = [];
		let a:number = 0;
		let i:number = 0;
        let r:number = 1000;

		for (i=0; i<=360; i++){
			a = UtilSP.radians(i);
			masterCircleAz_p[i] =  new THREE.Vector3(r*Math.cos(a), r*Math.sin(a), 0);
			masterCircleEl_p[i] =  new THREE.Vector3(r*Math.cos(a), 0, r*Math.sin(a));
		}
		let masterCircleAz_g:THREE.BufferGeometry= new THREE.BufferGeometry().setFromPoints(masterCircleAz_p);
		let masterCircleEl_g:THREE.BufferGeometry= new THREE.BufferGeometry().setFromPoints(masterCircleEl_p);
		let circle_mat:THREE.LineBasicMaterial = new THREE.LineBasicMaterial({ color:"gray", linewidth:1 } );

        let azCircles:Array<THREE.Line>;
        azCircles = [];
        let az:number;
        let iaz:number;
        for (iaz=0; iaz<18; iaz++){
            azCircles[iaz] = new THREE.Line(masterCircleAz_g, circle_mat); 
            az = iaz*10;
            azCircles[iaz].rotation.y = UtilSP.radians(az);
            this.azElGridDome.add(azCircles[iaz]);	
        }
        let elCircles:Array<THREE.Line>;
        elCircles = [];
        let el:number;
        let iel:number;
        for (iel=0; iel<9; iel++){
            elCircles[iel] = new THREE.Line(masterCircleEl_g, circle_mat); 
            el = iel*10;
            elCircles[iel].scale.x = Math.cos(UtilSP.radians(el));
            elCircles[iel].scale.z = elCircles[iel].scale.x;
            elCircles[iel].position.y = r * Math.sin(UtilSP.radians(el));
            this.azElGridDome.add(elCircles[iel]);	
        }

        let str:String3D_grp;
        str = new String3D_grp();
        str.lineHeight = 500;
        str.text = "N";
        this.azElGridDome.add(str);
        str.position.x = -r;
        str.rotation.y = UtilSP.radians(90);
        str.position.y = r/2;

        let azLabels:Array<String3D_grp>;
        azLabels = [];
        for (iaz=0; iaz<36; iaz++){
            az = iaz*10;
            azLabels[iaz] = new String3D_grp();
            azLabels[iaz].text = az.toFixed(0);
            azLabels[iaz].color = "lightgray";
            azLabels[iaz].justify = "center";
            azLabels[iaz].lineHeight = 50;
            azLabels[iaz].position.y = r*Math.sin(UtilSP.radians(15)) + azLabels[iaz].lineHeight;
            azLabels[iaz].rotation.y = UtilSP.radians(90-az);
            azLabels[iaz].position.z = -r*Math.sin(UtilSP.radians(az));
            azLabels[iaz].position.x = -r*Math.cos(UtilSP.radians(az));
            this.azElGridDome.add(azLabels[iaz]);
        }
        let elLabelSets:Array<THREE.Group>;
        elLabelSets = [];
        let elLabels:Array<Array<String3D_grp>>;
        elLabels = [];
        let k:number;
        let dEl:number = 3;
        for (k=0; k<4; k++){
            elLabelSets[k] = new THREE.Group();
            this.azElGridDome.add(elLabelSets[k]);
            elLabels[k] = [];
            for (iel =0; iel<8; iel++ ){
                el = iel*10 + 10;
                elLabels[k][iel] = new String3D_grp();
                elLabels[k][iel].text = el.toFixed(0);
                elLabels[k][iel].color = "darkgray";
                elLabels[k][iel].justify = "center";
                elLabels[k][iel].lineHeight = 50;  
                elLabels[k][iel].rotation.x = UtilSP.radians(el);
                elLabels[k][iel].position.y = r*Math.sin(UtilSP.radians(el+dEl));
                elLabels[k][iel].position.z = -r*Math.cos(UtilSP.radians(el+dEl));
                elLabelSets[k].add(elLabels[k][iel]);
            }
            elLabelSets[k].rotation.y = k*UtilSP.radians(90);
        }



        //let lonCircle_g:THREE.CircleGeometry = new THREE.CircleGeometry(1000);
        //let lonCircle_mat:THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial({color:"red"});
        //let lonCircle_m:THREE.Mesh = new THREE.Mesh(lonCircle_g, lonCircle_mat);
        //lonCircle_m.rotation.y = Math.PI/2;
        //lonCircle_m.position.y = 500;
	}    
    private makeConstantElCircle(){

        UtilSP.clearThreeJSGroup(this.constantElCircle); // Clears all children from a THREE.Group object

        if (!this._showConstantElCircleWall){
            return;

        }
		let masterCircleEl_p:Array<THREE.Vector3> = [];
		let a:number = 0;
		let i:number = 0;
        let r:number = 1000;

		for (i=0; i<=360; i++){
			a = UtilSP.radians(i);
			masterCircleEl_p[i] =  new THREE.Vector3(r*Math.cos(a), 0, r*Math.sin(a));
		}
		let masterCircleEl_g:THREE.BufferGeometry= new THREE.BufferGeometry().setFromPoints(masterCircleEl_p);
		let circle_mat:THREE.LineBasicMaterial = new THREE.LineBasicMaterial({ color:"red", linewidth:3 } );

        let elCircles:Array<THREE.Line>;
        elCircles = [];
        let el:number = this._constantElCircleElevation;
        let iel:number = 0;
        elCircles[iel] = new THREE.Line(masterCircleEl_g, circle_mat); 
        elCircles[iel].scale.x = Math.cos(UtilSP.radians(el));
        elCircles[iel].scale.z = elCircles[iel].scale.x;
        elCircles[iel].position.y = r * Math.sin(UtilSP.radians(el));
        this.constantElCircle.add(elCircles[iel]);	

        let radius:number = r * Math.cos(UtilSP.radians(el));
        let height:number = r * Math.sin(UtilSP.radians(el));
        let wall_g:THREE.CylinderGeometry = new THREE.CylinderGeometry(radius, radius, height, 360, 1, true);
        //let wall_mat:THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial({color:"red", side:THREE.DoubleSide});
        let wall_mat:THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial(
            {color:UtilSP.c2rgba(this.constantElCircleWallColor), transparent:true, opacity:this._constantElCircleWallAlpha0_100/100, side:THREE.DoubleSide});
        let wall_m:THREE.Mesh = new THREE.Mesh(wall_g, wall_mat);
        wall_m.position.y = height/2;
        this.constantElCircle.add(wall_m);	

        let str:String3D_grp;
        str = new String3D_grp();
        str.lineHeight = 500;
        str.text = "N";
        this.constantElCircle.add(str);
        str.position.x = -r;
        str.rotation.y = UtilSP.radians(90);
        str.position.y = r/2;

        let elLabelSets:Array<THREE.Group>;
        elLabelSets = [];
        let elLabels:Array<Array<String3D_grp>>;
        elLabels = [];
        let k:number;
        let dEl:number = 3;
        for (k=0; k<4; k++){
            elLabelSets[k] = new THREE.Group();
            this.constantElCircle.add(elLabelSets[k]);
            elLabels[k] = [];
            elLabels[k][iel] = new String3D_grp();
            elLabels[k][iel].text = "EL = "+el.toFixed(0)+"°";
            elLabels[k][iel].color = "black";
            elLabels[k][iel].justify = "center";
            elLabels[k][iel].lineHeight = 50;  
            elLabels[k][iel].rotation.x = UtilSP.radians(el);
            elLabels[k][iel].position.y = r*Math.sin(UtilSP.radians(el+dEl));
            elLabels[k][iel].position.z = -r*Math.cos(UtilSP.radians(el+dEl));
            elLabelSets[k].add(elLabels[k][iel]);
            elLabelSets[k].rotation.y = k*UtilSP.radians(90);
        }   
    
    }
    private updateCamera(){


        //this._netAz = UtilSP.mod360(this._azOffset + this._camAzDeg);
        //console.log("-------------");
        //console.log("entering  updateCamera cam parent name = "+this.renderSpace.camera.parent.name);

        let tweenFactor:number = 0.1;

        if (this._enableTweening ){
                // Update current pan, tilt, dist, fov, & lookat based on their velocities and the elapsed time.
            // If within tolerance of target, set to target.
            // Determine if tweening is finished.
            //let stillTweening:boolean = false;
            let dTilt:number =  this._currentTilt - this._targetTilt;
            if (Math.abs(dTilt) > 0.1){
                //console.log("Tilt: dTilt = "+dTilt+"  , t = "+this.tweenTimer.elapsedTime);
                this._currentTilt -= tweenFactor * dTilt; //this.vTilt * this.tweenTimer.elapsedTime * Math.sign(dTilt);
                this._stillTweening = true;
            } else {
                this._currentTilt = this._targetTilt;
            }

            let dPan:number =  UtilSP.diffAng(this._currentPan,this._targetPan);
                //console.log(dPan+"  "+this._currentPan+" "+this.tweenTimer.elapsedTime);
            if (Math.abs(dPan) > .1){
                //console.log("Pan: current = "+this._currentPan+", target = "+this._targetPan+", dPan = "+dPan+"  , t = "+this.tweenTimer.elapsedTime);
                this._currentPan -= tweenFactor * dPan; // * this.tweenTimer.elapsedTime * Math.sign(dPan);
                this._stillTweening = true;
            } else {
                this._currentPan = this._targetPan;
            }

            let dFOV:number =  this._currentFOV - this._targetFOV;
                //console.log(dPan+"  "+this._currentPan+" "+this.tweenTimer.elapsedTime);
            if (Math.abs(dFOV) > 1){
                this._currentFOV -= tweenFactor * dFOV; // * this.tweenTimer.elapsedTime * Math.sign(dFOV);
                this._stillTweening = true;
            } else {
                this._currentFOV = this._targetFOV;
            }

            let dDist:number =  this._currentDist - this._targetDist;
                //console.log(dPan+"  "+this._currentPan+" "+this.tweenTimer.elapsedTime);
            if (Math.abs(dDist) > 1){
                    this._currentDist -= tweenFactor * dDist;// * this.tweenTimer.elapsedTime * Math.sign(dDist);
                this._stillTweening = true;
            } else {
                this._currentDist = this._targetDist;
            }
            let rOrthoZoom:number =  this._currentOrthoZoom / this._targetOrthoZoom;
                //console.log(dPan+"  "+this._currentPan+" "+this.tweenTimer.elapsedTime);
            if (UtilSP.ratioAbs(rOrthoZoom, 1) > .01){
                let r = 1 + (rOrthoZoom - 1) * tweenFactor;
                this._currentOrthoZoom = (1/r) * this._currentOrthoZoom; 
                this._stillTweening = true;
            } else {
                this._currentOrthoZoom = this._targetOrthoZoom;
            }

            if (this._orbitMode){      
                //Tween LookAt:
                let dL:THREE.Vector3 =  this._targetLookat.clone(); 
                dL.sub(this._currentLookat);
                let dLmag:number = dL.length();
                dL.multiplyScalar(tweenFactor);  
                if ( dLmag > 1.0){
                    this._currentLookat.add(dL);
                    /*
                    console.log(
                        "Lookat: current = "+UtilSP.vector3toString(this._currentLookat,1)+
                        ", target = "+UtilSP.vector3toString(this._targetLookat,1)+
                        ", dL = "+UtilSP.vector3toString(dL,1)+
                        //", corr = "+UtilSP.vector3toString(corr,1)+
                        ", dLmag = "+dLmag+
                        ", t = "+this.tweenTimer.elapsedTime);   
                        */                    
                    this._stillTweening = true;

                } else {
                    this._currentLookat.copy(this._targetLookat);
                }
            } else {
                //Tween Position:
                let dP:THREE.Vector3 =  this._targetPos.clone(); 
                dP.sub(this._currentPos);
                let dPmag:number = dP.length();
                dP.multiplyScalar(tweenFactor);  
                if ( dPmag > 1.0){
                    this._currentPos.add(dP);
                    /*
                    console.log(
                        "Pos: current = "+UtilSP.vector3toString(this._currentPos,1)+
                        ", target = "+UtilSP.vector3toString(this._targetPos,1)+
                        ", dP = "+UtilSP.vector3toString(dP,1)+
                        //", corr = "+UtilSP.vector3toString(corr,1)+
                        ", dPmag = "+dPmag+
                        ", t = "+this.tweenTimer.elapsedTime);   
                    */                   
                    this._stillTweening = true;
                } else {
                    this._currentPos.copy(this._targetPos);
                }
            }  
            this.tweenTimer.reset();
            if (!this._stillTweening){
                this._tweeningIsActive = false;
            }               
        } else {
            // Not in tween mode.
            // Immediately set current values to targets.
            this._currentTilt = this._targetTilt;
            this._currentPan = this._targetPan;
            this._currentFOV = this._targetFOV;
            this._currentDist = this._targetDist; 
            this._currentOrthoZoom = this._targetOrthoZoom; 
            if (this._orbitMode){
                // Immediately set current lookat to target.
                this._currentLookat.copy(this._targetLookat);
            } else {
                // Immediately set current pos to target.
                this._currentPos.copy(this._targetPos);
            } 
        }
        if (this.cameraType == "ortho"){
            //console.log("In updateCamera, setting camOrthoZoom to "+this._currentOrthoZoom);
            this.renderSpace.camOrthoZoom = this._currentOrthoZoom;
        }

        if (this._orbitMode){
            //Calculate pos from lookat, pan, tilt, dist   
             this.camPan = 0;
            this.camTilt = 0;
            this._currentPos = this.calcPosition(this._currentLookat, this._currentPan, this._currentTilt, this._currentDist);
            this.pth.position.x = this._currentPos.x;
            this.pth.position.y = this._currentPos.y;
            this.pth.position.z = this._currentPos.z;
            this.camPan_grp.rotation.y = UtilSP.radians(this._currentPan);
            this.camTilt_grp.rotation.x = UtilSP.radians(this._currentTilt);           
            //this.renderSpace.refreshCam(this.FOV);
            this.renderSpace.camFOV = this._currentFOV;
            //this.renderSpace.perspectiveCamera.fov = this._currentFOV;
            //this.renderSpace.perspectiveCamera.near = 0.0001;
  
             //console.log(this.renderSpace.camera.localToWorld(new THREE.Vector3(0,0,0)));
        }else{
            this.camPan_grp.rotation.y = UtilSP.radians(this._currentPan);
            this.camTilt_grp.rotation.x = UtilSP.radians(this._currentTilt);   
            //this.renderSpace.refreshCam(this.FOV);
            //this.renderSpace.perspectiveCamera.fov = this._currentFOV;
            this.renderSpace.camFOV = this._currentFOV;
            //this.renderSpace.perspectiveCamera.near = 0.0001;
            this.pth.position.x = this._currentPos.x;
            this.pth.position.y = this._currentPos.y;
            this.pth.position.z = this._currentPos.z;     
        }
        this.renderSpace.camUpdateProjectionMatrix();
        //console.log("fov = "+this.renderSpace.perspectiveCamera.fov);
        let str:string = "Unicam ";
        str += "("+this.cameraType+") ";
        if(this._orbitMode){
            str += "ORBIT lookat= "+UtilSP.vector3toString(this._currentLookat,4);
        } else {
            str += "PANTILT pos= "+UtilSP.vector3toString(this._currentPos,4);
        }
        str += ", pan= "+this._currentPan.toFixed(1);
        str += ", tilt= "+this._currentTilt.toFixed(1);
        if (this.cameraType == "perspective" || this.cameraType == "fishEye"){
            str += ", distance = "+ this._currentDist.toFixed(2);
            str += ", FOV = "+this._currentFOV.toFixed(2);
        }

        this._shortSummary = str;
        if (this._consoleLogShortSummary){
            console.log(this._shortSummary);
        }
    }   
    public set orbitMode(newMode:boolean){
        this._orbitMode = newMode;
        //console.log("entering  set orbitMode = "+newMode+", cam name = "+this.renderSpace.camera.name+", cam parent name = "+this.renderSpace.camera.parent.name);
 
        if (this._orbitMode){
            //Switch pth parent
            //Convert current pth pos from previous parent to new parent (scene)
            //calculate pan and tilt from pos and lookat
            //this.renderSpace.scene.add(this.pth); ;
            this._pthParentOrbitMode.add(this.pth);
            this.azElGridDome.visible = false;
            this.constantElCircle.visible = false;
        } else {
            //Switch pth parent from scene to pthParent
            //set pth position to 0,0,0
            //set pth rotation back to 0 (how?)
            this._pthParentPanTiltMode.add(this.pth); 
            this.pth.position.x = 0;
            this.pth.position.y = 0;       
            this.pth.position.z = 0;
            this.pth.rotation.y = 0;       
            this.pth.rotation.z = 0; 
            this.pth.rotation.z = 0; 
            this.azElGridDome.visible = this._showAzElGridDome;     
            this.constantElCircle.visible = this._showConstantElCircle;     
             
        }
        this.renderSpace.camUpdateProjectionMatrix();
        this.updateCamera();
    }    
    public get orbitMode(){   
        return this._orbitMode;
    }
    public set pthParentPanTiltMode(obj:THREE.Object3D|THREE.Scene){
        //console.log("In set pthParent = "+obj);
        this._pthParentPanTiltMode = obj;
        this.orbitMode = this._orbitMode; // Use setter to make remaining changes
    }
    public get pthParentPanTiltMode(){
        return this._pthParentPanTiltMode;
    }
    public set pthParentOrbitMode(obj:THREE.Object3D|THREE.Scene){
        //console.log("In set pthParent = "+obj);
        this._pthParentOrbitMode = obj;
        this.orbitMode = this._orbitMode; // Use setter to make remaining changes
    }
    public get pthParentOrbittMode(){
        return this._pthParentOrbitMode;
    }    
    public set pixelSnap(val : number) {
        this._pixelSnap = val;
        this.updateCamera();
    }
    public get pixelSnap() : number {
        return this._pixelSnap;
    } 
    public get shortSummary(){
        return this._shortSummary;
    }
    public set consoleLogShortSummary(val:boolean){
        this._consoleLogShortSummary = val;
    }
    public get consoleLogShortSummary(){
        return this._consoleLogShortSummary;
    }
    public get positionSummary():string{

        //let lPos:THREE.Vector3 = this._targetPos.clone();
        //let wPos:THREE.Vector3 = this.renderSpace.camera.localToWorld(lPos).clone();    
       // let lLookat:THREE.Vector3 = this._targetLookat.clone();
        //let wLookat:THREE.Vector3 = this.renderSpace.camera.localToWorld(lLookat).clone();
        let lPos:THREE.Vector3 = this.renderSpace.camera.position.clone();
        let  wPos:THREE.Vector3 = lPos.clone();
        this.renderSpace.camera.localToWorld(wPos);

        let str:string = "";

        str += "cameraType = "+this.cameraType+"\n";
        str += "orbitMode = "+this._orbitMode+"\n";
        str +=     "enableTweening = "+this._enableTweening+", mouseIsDown = "+this._mouseIsDown+"\n";
        str +=     "tweeningIsActive = "+this._tweeningIsActive+"\n";
        str +=     "Current:";
        if (this.cameraType == "perspective" || this.cameraType == "fishEye"){
            str +=     "\nDistance = "+ UtilSP.formatDecimals(this._currentDist,2);
            str +=     "\nFOV = "+UtilSP.formatDecimals(this._currentFOV,2);
        } else {
            str +=     "\northoZoom = "+UtilSP.formatDecimals(this._currentOrthoZoom,3);
        }
        str +=     "\npan = "+UtilSP.formatDecimals(this._currentPan,2);
        str +=     "\ntilt = "+UtilSP.formatDecimals(this._currentTilt,2);
        str +=     "\nLookat = "+UtilSP.vector3toString(this._currentLookat,1) ;
        str +=     "\nPos = "+UtilSP.vector3toString(this._currentPos,1) ;
        str +=     "\nTarget:";
        if (this.cameraType == "perspective" || this.cameraType == "fishEye"){
            str +=     "\nDistance = "+ UtilSP.formatDecimals(this._targetDist,2);
            str +=     "\nFOV = "+UtilSP.formatDecimals(this._targetFOV,2);
        } else {
            str +=     "\northoZoom = "+UtilSP.formatDecimals(this._targetOrthoZoom,3);
        }
        str +=     "\npan = "+UtilSP.formatDecimals(this._targetPan,2);
        str +=     "\ntilt = "+UtilSP.formatDecimals(this._targetTilt,2);
        /*
        "\nLocal:"+
        "\ncamLookat = "+UtilSP.vector3toString(lLookat,1) +
        "\ncamPos = "+UtilSP.vector3toString(lPos,1) +
        "\nWorld:"+
        "\ncamLookat = "+UtilSP.vector3toString(wLookat,1) +
        "\ncamPos = "+UtilSP.vector3toString(wPos,1) ;
        */
        
        let camMatrix:THREE.Matrix4 = this.renderSpace.camera.matrix.clone();
        let camPosL:THREE.Vector3 = new THREE.Vector3();
        camPosL.setFromMatrixPosition(camMatrix);
        let camEulerL:THREE.Euler = new THREE.Euler();
        camEulerL.setFromRotationMatrix(camMatrix);

        let camMatrixW:THREE.Matrix4 = this.renderSpace.camera.matrixWorld.clone();
        let camPosW:THREE.Vector3 = new THREE.Vector3();
        camPosW.setFromMatrixPosition(camMatrixW);
        let camEulerW:THREE.Euler = new THREE.Euler();
        camEulerW.setFromRotationMatrix(camMatrixW);

        str += "\n\nWorld:";
        str += "\nPos ="+UtilSP.vector3toString(camPosW , 1)   ;   
        str += "\nEuler: "+ UtilSP.euler2string(camEulerW , 1)   ;;
        str += "\nLocal:";
        str += "Pos = "+UtilSP.vector3toString(camPosL , 1)   ;         
        str += "\nEuler: "+ UtilSP.euler2string(camEulerL , 1)   ;;

        
        //this.renderSpace.camera.getWorldPosition(new THREE.Vector3(0,200,0)); //this._targetLookat
        //str += UtilSP.vector3toString(wPos,1) ;
        return str;
    }
    public get inMotion():boolean{
        return this._tweeningIsActive;
    }
 
    onMouseMove(event){
        //console.log("In unicam, onMouseMove, this.lastMousePos.outOfBounds = "+this.lastMousePos.outOfBounds);
        if (!this._enableDrag){
            return;
        }
        const pos = canvasPos(this.renderSpace.getCanvas(), event);
        this.lastMousePos = pos;

        if(!this._mouseIsDown ) return;

        if (this._allowOutOfBounds || !pos.outOfBounds){
            let deltaX = (pos.x - this._lastxStage)*this._pixelSnap;
            this._lastxStage = pos.x;

            let deltaY = (pos.y - this._lastyStage)*this._pixelSnap;
            this._lastyStage = pos.y;
            //console.log("deltaX = "+deltaX+", deltaY = "+deltaY);
            if (this._orbitMode){
                this.pan -= deltaX;
                this.tilt -= deltaY;
            } else {
                this.pan -= deltaX;
                this.tilt += deltaY;
            }             
            this.tilt = UtilSP.minmax(this.tilt, this._tiltMin, this._tiltMax);
           //console.log(this.positionSummary);
        }
        this.updateCamera();
    }
    // Setters: set target settings and start timer;

    public set cameraType(val:string){
        if (val == "perspective"){
            this.renderSpace.cameraType = "perspective";
        } else if (val == "ortho"){
            this.renderSpace.cameraType = "ortho";
        } else if (val == "fishEye") {
            this.renderSpace.cameraType = "fishEye";
        } else {
            console.log("ERROR in universal-camera-handler: invalid cameraType "+val+". Choices are: perspective ortho fishEye" )
        }
    }
    public get cameraType():string{
        return this.renderSpace.cameraType;
    }


    public set tilt(val:number){
        this.tweenTimer.reset();
        this._targetTilt = UtilSP.pm180(val);
        this._tweeningIsActive = true;
        this.updateCamera();
    }
    public get tilt(){
        return this._currentTilt;
    }
    public set pan(val:number){
        this.tweenTimer.reset();
        this._targetPan = UtilSP.mod360(val);
        this._tweeningIsActive = true;
        this.updateCamera();
    }
    public get pan(){
        return this._currentPan;
    }  
    public set distance(val:number){
        if (val == this._targetDist){
            return; // No change
        }
        this.tweenTimer.reset();
        this._targetDist = val;
        this.updateCamera();
    }
    public get distance(){
        return this._currentDist;
    } 
    public set FOV(val:number){
        this.tweenTimer.reset();
        this._targetFOV = val;
        this.updateCamera();
    }
    public get FOV(){
        return this._currentFOV;
    } 
    public set orthoZoom(val:number){
        this.tweenTimer.reset();
        this._targetOrthoZoom = val;
        this.updateCamera();
    }
    public get orthoZoom(){
        return this._currentOrthoZoom;
    }    
    public set minDistance(val:number){
        this._minDistance = val;
        this.updateCamera();
    }
    public get minDistance(){
        return this._minDistance;
    } 
    public set maxDistance(val:number){
        this._maxDistance = val;
        this.updateCamera();
    }
    public get maxDistance(){
        return this._maxDistance;
    } 
    public set minFOV(val:number){
        this._minFOV = val;
        this.updateCamera();
    }
    public get minFOV(){
        return this._minFOV;
    } 
    public set maxFOV(val:number){
        this._maxFOV = val;
        this.updateCamera();
    }
    public get maxFOV(){
        return this._maxFOV;
    } 
    public set lookat(val:THREE.Vector3){
        this.tweenTimer.reset();
        this._targetLookat = val;
        this.updateCamera();
    }
    public get lookat():THREE.Vector3{
        return this._currentLookat;
    } 
    public set lookatX(val:number){
        this.tweenTimer.reset();
        let vtemp:THREE.Vector3 = this._targetLookat.clone();
        vtemp.x = val;
        this._targetLookat = vtemp;
        this.updateCamera();
    }
    public get lookatX():number{
        return this._currentLookat.x;
    } 
    public set lookatY(val:number){
        this.tweenTimer.reset();
        let vtemp:THREE.Vector3 = this._targetLookat.clone();
        vtemp.y = val;
        this._targetLookat = vtemp;
        this.updateCamera();
    }
    public get lookatY():number{
        return this._currentLookat.y;
    } 
    public set lookatZ(val:number){
        this.tweenTimer.reset();
        let vtemp:THREE.Vector3 = this._targetLookat.clone();
        vtemp.z = val;
        this._targetLookat = vtemp;
        this.updateCamera();
    }
    public get lookatZ():number{
        return this._currentLookat.z;
    } 
    public set pos(val:THREE.Vector3){
        this.tweenTimer.reset();
        this._targetPos = val;
        //console.log("Set pos, this._targetPos = "+UtilSP.vector3toString(this._targetPos)  );
        this.updateCamera();
    }
    public get pos():THREE.Vector3{
        return this._currentPos;
    } 
   public set posX(val:number){
        this.tweenTimer.reset();
        let vtemp:THREE.Vector3 = this._targetPos.clone();
        vtemp.x = val;
        this._targetPos = vtemp;
        this.updateCamera();
    }
    public get posX():number{
        return this._currentPos.x;
    } 
   public set posY(val:number){
        this.tweenTimer.reset();
        let vtemp:THREE.Vector3 = this._targetPos.clone();
        vtemp.y = val;
        this._targetPos = vtemp;
        this.updateCamera();
    }
    public get posY():number{
        return this._currentPos.y;
    } 
   public set posZ(val:number){
        this.tweenTimer.reset();
        let vtemp:THREE.Vector3 = this._targetPos.clone();
        vtemp.z = val;
        this._targetPos = vtemp;
        this.updateCamera();
    }
    public get posZ():number{
        return this._currentPos.z;
    }
    public set showAzElGridDome(val:boolean){
        this._showAzElGridDome = val;
        if (this._orbitMode){
            this.azElGridDome.visible = val;
        } else {
            this.azElGridDome.visible = this._showAzElGridDome;
        }
    }
    public get showAzElGridDome(){
        return this._showAzElGridDome;
    }
    public set enableMouseAndWheel(val:boolean){
        //this._enableMouseAndWheel = val;
        //console.log("in set enableMouseAndWheel = "+val);
        this._enableDrag = val;
        this._enableWheel = val;
    }
    public get enableMouseAndWheel(){
        //return this._enableMouseAndWheel;
        return (this._enableDrag && this._enableWheel);
    }
    set enableDrag(val : boolean) {
        this._enableDrag = val;
        //console.log("In unicam, set enableDrag = "+val)
    }
    get enableDrag() : boolean {
        return this._enableDrag;
    }  
    set enableWheel(val : boolean) {
        this._enableWheel = val;
    }
    get enableWheel() : boolean {
        return this._enableWheel;
    }       
    public set enableTweening(newMode:boolean){
        this._enableTweening = newMode;
        this.updateCamera();
    }    
    public get enableTweening(){   
        return this._enableTweening;
    }
    public get currentlyTweening(){   
        return this._stillTweening;
    }

    public get mouseIsDown(){
        return this._mouseIsDown;
    }
    
    public set tiltMin(val:number){
        this._tiltMin = val;
    }
    public get tiltMin(){
        return this._tiltMin;
    }
    public set tiltMax(val:number){
        this._tiltMax = val;
    }
    public get tiltMax(){
        return this._tiltMax;
    }

    private set camPan(val){
        this.camPan_grp.rotation.y = UtilSP.radians(val);
    }
    private set camTilt(val){
        this.camTilt_grp.rotation.z = UtilSP.radians(val);
    }    
    public set constantElCircleElevation(val:number){
        this._constantElCircleElevation = val;
        this.makeConstantElCircle();
    }
    public get constantElCircleElevation(){
        return this._constantElCircleElevation;
    } 


    public set constantElCircleWallColor(val:string){
        this._constantElCircleWallColor = val;
        this.makeConstantElCircle();
    }
    public get constantElCircleWallColor(){
        return this._constantElCircleWallColor;
    }  
    public set constantElCircleWallAlpha0_100(val:number){
        this._constantElCircleWallAlpha0_100 = val;
        this.makeConstantElCircle();
    }
    public get constantElCircleWallAlpha0_100(){
        return this._constantElCircleWallAlpha0_100;
    }  
    public set showConstantElCircleWall(val:boolean){
        this._showConstantElCircleWall = val;
        this.makeConstantElCircle();
    }
    public get showConstantElCircleWall(){
        return this._showConstantElCircleWall;
    }     
         
    private calcPosition(lookat:THREE.Vector3, pan:number, tilt:number, dist:number):THREE.Vector3{
        // Reverse calculation from calcLookat
        let r:number = dist
        let r2:number = r*Math.cos(UtilSP.radians(tilt)); // Projected radius onto X-Z plane
        let xx:number = r2*Math.sin( UtilSP.radians(pan+180));
        let yy:number = r*Math.sin(UtilSP.radians(tilt));
        let zz:number = r2*Math.cos( UtilSP.radians(pan+180));
        let pos:THREE.Vector3 = new THREE.Vector3(lookat.x - xx, lookat.y - yy, lookat.z - zz);
        return pos;
    }
    private calcLookat(pos:THREE.Vector3, pan:number, tilt:number, dist:number):THREE.Vector3{
        // Returns the lookat point give the look-from point (pos),
        // pan (+ve = angle from z axis CCW viewed down from +Y)
        // tilt (+ve = +ve y above P)
        let r:number = dist
        let r2:number = r*Math.cos(UtilSP.radians(tilt)); // Projected radius onto X-Z plane
        let xx:number = r2*Math.sin( UtilSP.radians(pan+180));
        let yy:number = r*Math.sin(UtilSP.radians(tilt));
        let zz:number = r2*Math.cos( UtilSP.radians(pan+180));
        let lookat:THREE.Vector3 = new THREE.Vector3(xx+pos.x, yy+pos.y, zz+pos.z);
        return lookat;
    } 
    
    public doEveryFrame() {
        //console.log('in doEveryFrame');
        this.updateCamera();
    }  
    public snapTo(pan:number, tilt:number, distance?:number){
        let saveTween:boolean = this.enableTweening
        this.enableTweening = false;
        this._targetPan = pan;
        this._targetTilt = tilt;
        if (distance){
            this._targetDist = distance;
        }
        this.updateCamera();
        this.enableTweening = saveTween;
    }       
}

const canvasPos = (canvas, event) => {
    const canvasPos = canvas.getBoundingClientRect();
    let { clientX : x,  clientY: y } = event;
    x -= canvasPos.left;
    y -= canvasPos.top;
    let outOfBounds:boolean = (x < 0 || x > canvasPos.width || y < 0 || y > canvasPos.height);
    //console.log("in universal-camera-handler, x = "+x+", left = "+canvasPos.left+", width = "+canvasPos.width+
    //", y = "+y+", height = "+canvasPos.height+", outOfBounds = "+outOfBounds);

   return { x, y, outOfBounds }
}

